import * as actions from "../../actions/onm-action/types";

const INITIAL_STATE = {
  activities: {
    get: {
      loading: false,
      reset: false,
      success: {
        ok: false,
        data: {
          upcoming_activities: [],
          completed_activities: [],
          past_activities: [],
          ongoing_activities: [],
        },
      },
      failure: {
        error: false,
        message: "",
      },
    },
  },
  documents: {
    get: {
      loading: false,
      reset: false,
      success: {
        ok: false,
        data: [],
      },
      failure: {
        error: false,
        message: "",
      },
    },
  },
  projectOverviewList: {
    get: {
      loading: false,
      reset: false,
      success: {
        ok: false,
        data: [],
      },
      failure: {
        error: false,
        message: "",
      },
    },
  },
  showOnM: false,
};

const onmReducers = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actions.GET_ONM_ACTIVITIES_LOADING:
      return {
        ...state,
        activities: {
          ...state.activities,
          get: {
            ...state.activities.get,
            loading: true,
            reset: false,
            success: {
              ...state.activities.get.success,
              ok: false,
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case actions.GET_ONM_ACTIVITIES_SUCCESS:
      return {
        ...state,
        activities: {
          ...state.activities,
          get: {
            ...state.activities.get,
            loading: false,
            reset: false,
            success: {
              ...state.activities.get.success,
              ok: true,
              data: action.payload,
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case actions.GET_ONM_ACTIVITIES_FAILURE:
      return {
        ...state,
        activities: {
          ...state.activities,
          get: {
            ...state.activities.get,
            loading: false,
            reset: false,
            success: {
              ...state.activities.get.success,
              ok: false,
              data: {
                upcoming_activities: [],
                completed_activities: [],
                past_activities: [],
                ongoing_activities: [],
              },
            },
            failure: {
              error: true,
              message: action.payload.message,
            },
          },
        },
      };
    case actions.GET_ONM_ACTIVITIES_RESET:
      return {
        ...state,
        activities: {
          ...state.activities.get,
          get: {
            ...INITIAL_STATE.activities.get,
            reset: true,
          },
        },
      };
    case actions.GET_ONM_DOCUMENTS_LOADING:
      return {
        ...state,
        documents: {
          ...state.documents,
          get: {
            ...state.documents.get,
            loading: true,
            reset: false,
            success: {
              ...state.documents.get.success,
              ok: false,
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case actions.GET_ONM_DOCUMENTS_SUCCESS:
      return {
        ...state,
        documents: {
          ...state.documents,
          get: {
            ...state.documents.get,
            loading: false,
            reset: false,
            success: {
              ...state.documents.get.success,
              ok: true,
              data: action.payload,
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case actions.GET_ONM_DOCUMENTS_FAILURE:
      return {
        ...state,
        documents: {
          ...state.documents,
          get: {
            ...state.documents.get,
            loading: false,
            reset: false,
            success: {
              ...state.documents.get.success,
              ok: false,
              data: {
                upcoming_documents: [],
                completed_documents: [],
                past_documents: [],
              },
            },
            failure: {
              error: true,
              message: action.payload.message,
            },
          },
        },
      };
    case actions.GET_ONM_DOCUMENTS_RESET:
      return {
        ...state,
        documents: {
          ...state.documents.get,
          get: {
            ...INITIAL_STATE.documents.get,
            reset: true,
          },
        },
      };
    case actions.GET_PROJECTS_OVERVIEW_LIST_LOADING:
      return {
        ...state,
        projectOverviewList: {
          ...state.projectOverviewList,
          get: {
            ...state.projectOverviewList.get,
            loading: true,
            reset: false,
            success: {
              ...state.projectOverviewList.get.success,
              ok: false,
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case actions.GET_PROJECTS_OVERVIEW_LIST_SUCCESS:
      return {
        ...state,
        projectOverviewList: {
          ...state.projectOverviewList,
          get: {
            ...state.projectOverviewList.get,
            loading: false,
            reset: false,
            success: {
              ...state.projectOverviewList.get.success,
              ok: true,
              data: action.payload,
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case actions.GET_PROJECTS_OVERVIEW_LIST_FAILURE:
      return {
        ...state,
        projectOverviewList: {
          ...state.projectOverviewList,
          get: {
            ...state.projectOverviewList.get,
            loading: false,
            reset: false,
            success: {
              ...state.projectOverviewList.get.success,
              ok: false,
              data: [],
            },
            failure: {
              error: true,
              message: action.payload.message,
            },
          },
        },
      };
    case actions.GET_PROJECTS_OVERVIEW_LIST_RESET:
      return {
        ...state,
        projectOverviewList: {
          ...state.projectOverviewList.get,
          get: {
            ...INITIAL_STATE.projectOverviewList.get,
            reset: true,
          },
        },
      };
    case actions.IS_ONM_ENABLED_SUCCESS:
      return {
        ...state,
        showOnM: action.payload,
      };
    case actions.GET_ONM_ACTIVITIES_FAILURE:
      return {
        ...state,
        showOnM: false,
      };
  }
  return state;
};

export default onmReducers;
